export const dbTabs1 = {
  presentation: {
    descriptionTitle: "Descrição do anúncio",
    descriptionSub: "Escolha se a descrição aparece na página de reservas diretas de cada unidade.",
    visible: "Visível",
    hidden: "Oculta",
    amenitiesTitle: "Serviços incluídos",
    amenitiesSub: "Defina quais serviços e comodidades são exibidos para cada unidade no seu motor de reservas.",
    amenitiesCount: "{count} serviço | {count} serviços",
    editAmenitiesTitle: "Editar serviços",
    edit: "Editar",
    imagesTitle: "Imagens da acomodação",
    imagesSubtitle: "Envie, reordene e defina a imagem principal de cada unidade que aparecerá no seu motor de reservas.",
  },
  reservations: {
    updating: "Atualizando…",
    engineActive: "Motor ativo",
    engineInactive: "Motor inativo",
    engineActiveDesc: "Os hóspedes podem reservar quartos diretamente pelo seu link.",
    engineInactiveDesc: "As reservas diretas estão desativadas para este hotel.",
    statusActive: "Ativo",
    statusInactive: "Inativo",
    roomsAvailable: "Quartos disponíveis",
    colRoom: "Quarto",
    colCap: "Cap.",
    colActive: "Ativo",
    noRooms: "Nenhum quarto configurado.",
    hotelLabel: "Hotel",
    unitActive: "Ativo",
    unitInactive: "Inativo",
    enableNotice: "Ative as reservas diretas para gerenciar os quartos.",
    toastUpdated: "Atualizado.",
    toastUpdateError: "Não foi possível atualizar.",
    toastGlobalUpdated: "Status global atualizado.",
  },
  promotions: {
    title: "Promoções nas reservas diretas",
    subtitle: "Controle quais estão ativas, se podem ser acumuladas e a ordem delas.",
    loading: "Carregando promoções…",
    empty: "Nenhuma promoção configurada para esta propriedade.",
    dragTitle: "Arraste para reordenar",
    switchTitle: "Ativa nas reservas diretas",
    badgeLabel: "Selo",
    badgePlaceholder: "ex.: -10% / Oferta",
    stackableLabel: "Acumulável",
    tip: "Dica: ative a promoção para aplicá-la nas reservas diretas e use “Acumulável” se ela puder ser combinada com outras promoções.",
    toastLoadError: "Não foi possível carregar as promoções.",
    toastSaved: "Promoções salvas com sucesso.",
    toastSaveError: "Não foi possível salvar as promoções.",
    dateFrom: "A partir de {date}",
    dateUntil: "Até {date}",
  },
  addons: {
    title: "Ocupação e cobranças",
    hint1: "Um único ajuste por {scope}: redução para menos hóspedes",
    hintOr: "ou",
    hint2: "acréscimo por hóspede extra. Não os dois.",
    perRoom: "quarto",
    perAccommodation: "acomodação",
    loading: "Carregando configuração…",
    emptyHotel: "Este hotel não tem quartos configurados.",
    thisAccommodation: "Esta acomodação",
    modeReduction: "Redução",
    modeSurcharge: "Acréscimo",
    modeNone: "Sem ajuste",
    toastLoadError: "Não foi possível carregar a configuração de ocupação.",
    toastSaved: "Ocupação salva com sucesso.",
    toastSaveError: "Não foi possível salvar a ocupação.",
  },
};
